// components/ChatboxFooter.jsx
import { X } from 'lucide-react';
import { DEFAULT_IMAGES } from '../constants';

const PrivacyNotice = ({ widgetDetails, onClose }) => {
  return (
    <div className='chat-privacy-text d-flex justify-content-between align-items-center' style={{ background: widgetDetails?.inside_btn_secondary_bg }}>
      <p className='mb-0' style={{ color: widgetDetails?.inside_btn_secondary_text }}>
        By chatting, you agree to our{' '}
        <a
          href='https://www.comniqai.com/privacy-policy'
          target='_blank'
          rel='noopener noreferrer'
          className='privacy-link outfit-medium'
          style={{ color: widgetDetails?.inside_btn_primary_bg }}
        >
          Privacy Policy
        </a>
        .
      </p>
      <button type='button' className='privacy-close-btn' onClick={onClose}>
        <X size={12} style={{ color: widgetDetails?.inside_btn_secondary_text }} />
      </button>
    </div>
  );
};

const PoweredBy = ({ widgetDetails }) => {
  return (
    <a href='https://www.comniqai.com' target='_blank' rel='noopener noreferrer' className='d-flex align-items-center'>
      <img src={DEFAULT_IMAGES.SIDEBAR_BOX_IMG} alt='ComniqAI Logo' className='footer-logo' title='ComniqAI' />
      <h3
        className='outfit-regular mb-0'
        style={{
          color: widgetDetails?.text_color,
          fontSize: `${widgetDetails?.windo_font_size}px`,
        }}
      >
        Powered by
      </h3>
      <span className='outfit-bold lead-summary-color mb-0' style={{ fontSize: `${widgetDetails?.windo_font_size}px` }}>
        ComniqAI
      </span>
    </a>
  );
};

export const ChatboxFooter = ({ showPrivacy, welcomeDetails, widgetDetails, onClosePrivacy }) => {
  const shouldShowFooter = (showPrivacy && welcomeDetails?.lead_status) || welcomeDetails?.is_powered_by_visible;

  if (!shouldShowFooter) return null;

  return (
    <div className={`custom-chat-footer ${showPrivacy && welcomeDetails?.lead_status ? 'p-3' : ''}`}>
      {showPrivacy && welcomeDetails?.lead_status && <PrivacyNotice widgetDetails={widgetDetails} onClose={onClosePrivacy} />}

      {welcomeDetails?.is_powered_by_visible && <PoweredBy widgetDetails={widgetDetails} />}
    </div>
  );
};
